export const SMALL_SIZE = 'sm'
export const MEDIUM_SIZE = 'md'
export const LARGE_SIZE = 'lg'


// WEBPACK FOOTER //
// ./src/constants/sizes.js